import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { LegalsFooterLinkItemBlockConfig } from '@front-platform/content-builder';
import { legalsFooterLinkItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface LegalsFooterLinkItemBlockRuntimeConfig {}

export type LegalsFooterLinkItemBlockConfigInput = Partial<
  Omit<LegalsFooterLinkItemBlockConfig, keyof LegalsFooterLinkItemBlockRuntimeConfig> &
    LegalsFooterLinkItemBlockRuntimeConfig
>;
export type LegalsFooterLinkItemBlockResolvedConfig = Omit<
  LegalsFooterLinkItemBlockConfig,
  keyof LegalsFooterLinkItemBlockRuntimeConfig
> &
  Partial<LegalsFooterLinkItemBlockRuntimeConfig>;
export interface LegalsFooterLinkItemBlockContract extends ConfigComponentContract<
  LegalsFooterLinkItemBlockConfigInput,
  LegalsFooterLinkItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-legals-footer-link-block',
  templateUrl: './legals-footer-link-item-block.component.html',
  styleUrls: ['./legals-footer-link-item-block.component.scss'],
  standalone: false,
})
export class LegalsFooterLinkItemBlockComponent implements LegalsFooterLinkItemBlockContract {
  readonly config = input<LegalsFooterLinkItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    LegalsFooterLinkItemBlockConfig,
    LegalsFooterLinkItemBlockRuntimeConfig
  >(legalsFooterLinkItemBlockResolveConfig, () => ({ config: this.config() }));
  get name(): string {
    return this.resolvedConfig()['name'] as unknown as string;
  }
  get link(): string | undefined {
    return this.resolvedConfig()['link'] as unknown as string | undefined;
  }
  get openInNewTab(): boolean | undefined {
    return this.resolvedConfig()['open_in_new_tab'] as unknown as boolean | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(LegalsFooterLinkItemBlockComponent, {
  'keyAliases': {},
});
